/**
 * @param {string} slug
 * @returns {string}
 */
export function sanitizeExportSlug(slug) {
  const safe = String(slug || 'export')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return safe || 'export';
}

/**
 * @param {Date} [d]
 * @returns {string} YYYY-MM-DD
 */
export function formatExportDate(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * @param {string} slug
 * @param {string} extension e.g. csv or xlsx (no dot)
 * @returns {string}
 */
export function buildExportFilename(slug, extension) {
  const safe = sanitizeExportSlug(slug);
  const date = formatExportDate();
  const ext = String(extension).replace(/^\./, '');
  return `${safe}_${date}.${ext}`;
}

/**
 * @param {string} filename
 * @param {Blob} blob
 */
export function downloadBlob(filename, blob) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = 'noopener';
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
